/**
 * Share-modal state. Not persisted — this is a transient UI trigger, not a
 * preference — but still a store rather than local component state, because
 * the trigger (homepage banner, footer link, and eventually per-guide "Share
 * this guide" buttons) and the modal that renders it live in different parts
 * of the tree. `context` is carried through only for the analytics event
 * (which surface opened the modal), never for anything user-authored.
 */

import { create } from 'zustand'
import { HOMEPAGE_SHARE_RESOURCE, type ShareResource } from '@/lib/share'

interface ShareState {
  open: boolean
  resource: ShareResource
  context: string
  openShare: (resource: ShareResource, context: string) => void
  closeShare: () => void
}

export const useShareStore = create<ShareState>()((set) => ({
  open: false,
  resource: HOMEPAGE_SHARE_RESOURCE,
  context: 'homepage',
  openShare: (resource, context) => set({ open: true, resource, context }),
  closeShare: () => set({ open: false }),
}))
